
import { Globe } from 'lucide-react';

const BangladeshHeader = () => {
  return (
    <div className="text-center mb-8 animate-fade-in">
      <div className="flex items-center justify-center mb-3 animate-scale-in" style={{ animationDelay: '0.2s' }}>
        <span className="text-3xl mr-2 animate-bounce" style={{ animationDuration: '2s' }}>🇧🇩</span>
        <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 bg-gradient-to-r from-green-600 via-gray-900 to-red-600 bg-clip-text text-transparent">
          100% US Residential Proxy, VPN & Remote Desktop Solutions
        </h1>
      </div>
      <div className="flex items-center justify-center mb-4 animate-slide-in-right" style={{ animationDelay: '0.4s' }}>
        <span className="text-lg text-gray-600 font-medium">From Bangladesh to the World</span>
        <Globe className="ml-2 h-5 w-5 text-green-600 animate-spin" style={{ animationDuration: '8s' }} />
      </div>
      
      {/* Compact Value Prop */}
      <div className="inline-flex items-center px-4 py-2 bg-gradient-to-r from-green-100 to-red-100 rounded-full mb-3 shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 animate-fade-in" style={{ animationDelay: '0.6s' }}>
        <span className="text-lg animate-pulse">🚀</span>
        <span className="ml-2 font-bold text-gray-900">Access Real Residential Connections</span>
      </div>
      
      {/* Customer Count */}
      <div className="text-center animate-fade-in" style={{ animationDelay: '0.8s' }}>
        <div className="inline-flex items-center px-3 py-1 bg-gradient-to-r from-green-500 to-green-600 text-white rounded-full shadow-lg transform hover:scale-110 transition-all duration-300">
          <span className="text-sm animate-pulse">⭐</span>
          <span className="ml-2 font-bold text-sm">2,000+ Satisfied Customers</span>
        </div>
      </div>
    </div>
  );
};

export default BangladeshHeader;
